var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function Svg8BitSpeaker(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 12.91 12.91",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.24,0V1.61H9.68V0ZM9.68,1.61V3.23H11.3V1.61ZM11.3,3.23V9.68h1.61V3.23Zm0,6.45H9.68V11.3H11.3V9.68ZM9.68,11.3H8.07v1.61H9.68V11.3ZM3.23,1.61V3.23H1.61V4.84H0V8.07H1.61V9.68H3.23V11.3H4.84V1.61ZM6.46,3.23V4.84H8.07V3.23ZM8.07,4.84V8.07H9.68V4.84Zm0,3.23H6.46V9.68H8.07V8.07Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg8BitSpeaker);
export default __webpack_public_path__ + "static/media/8-bit_speaker.d3cbff15190393efd2818a756df13b95.svg";
export { ForwardRef as ReactComponent };